const useExternalReferrer = async (auctioncore, setProperty, query) => {
  try {
    const qsYear = query.get('year');
    const qsVin = query.get('vin') || null;
    const qsBrandID = query.get('brandID');
    const qsModelID = query.get('modelID');
    const qsMileage = query.get('mileage');

    const qsBrandText = query.get('make');
    const qsModelText = query.get('model');

    setProperty('year', qsYear || null);
    setProperty('make', qsBrandID || null);
    setProperty('model', qsModelID || null);

    console.log('qsModelID:', qsModelID);

    if (qsMileage) setProperty('mileage', qsMileage);

    if (qsBrandID && qsModelID) {
      return {
        success: true,
      };
    }

    if (qsVin !== null && qsVin !== 'null') {
      const vinResponse = await auctioncore.doVinDecode(qsVin);

      const {
        vehicleYear, vehicleBrandID, vehicleModelID,
      } = vinResponse.data.items[0];

      if (qsVin) setProperty('vin', qsVin);
      setProperty('year', vehicleYear || null);
      setProperty('make', vehicleBrandID || null);
      setProperty('model', vehicleModelID || null);
      return {
        success: true,
      };
    }

    const brandID = await auctioncore.getVehicleBrands()
      .then((response) => {
        const brand = response.data.lookupItems.filter((item) => item.text.toLowerCase() === qsBrandText.toLowerCase());
        return brand[0].value;
      });

    setProperty('make', brandID || null);

    const modelID = await auctioncore.getVehicleModels(qsYear, brandID)
      .then((response) => {
        const model = response.data.lookupItems.filter((item) => item.text.toLowerCase() === qsModelText.toLowerCase());
        return model[0].value;
      });

    setProperty('model', modelID || null);

    setProperty('externalReferrer', true);

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error,
    };
  }
};

export default useExternalReferrer;
